import styled from 'styled-components'
import { Pagination } from 'antd'

export const StyledPagination = styled(Pagination)`
  .ant-pagination-item {
    display: none;
  }
`
